/*
saikrishna 10/06/2022  3075154998  Removed unecesarry console.log statements
saikrishna 10/11/2022  3075154998  Fixed Payload in DMRecordTable,NightJobsTable
Suresh Peddavoora 10/26/2022 3075154998  Added Record group button in table header
Akhila  10/28/2022 3075154998 data manager ux changes
Suresh Peddavoora 10/28/2022 3075154998  Added Rows per screen text in table pagination
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Raghu 11/30/2022 3075154998 Table footer styling fixes
*/
import React, {createRef, useState} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination} from '@material-ui/core';
import {SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';

export default function DMSearchTable({searchData, submit, setSubmit, setValue, setFilterCode}) {
  // const [message, setMessage] = useState('');
  const message = '';
  const columns = [
    {
      title: 'Code',
      field: 'code',
    },
    {
      title: 'Description',
      field: 'description',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
    },
    {
      title: 'Record Type',
      field: 'recordType',
    },
  ];
  const [rows, setRows] = useState(defaultRows);
  const tableRef = createRef();
  const dispatch = useDispatch();

  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table custom-actions-icon custom-toolbar-icons global-field-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            // isLoading={isLoading}
            // data={[]}
            data={(query) =>
              new Promise((resolve) => {
                const url = `dmrecord/findall/recordgroup`;
                const bodyObj = {
                  // description: searchData?.description ? searchData?.description : "",
                  // limit: query.pageSize ? query.pageSize : null,
                  // name: searchData?.name ? searchData.name : "",
                  // page: submit
                  //   ? 1
                  //   : arrayLast && query?.page >= 1
                  //   ? query.page
                  //   : arrayLast
                  //   ? (query.page <= 1 && query.page + 1) || query.page - 1
                  //   : query.page + 1,
                  description: '',
                  limit: 5,
                  page: 1,
                  recordGroupCode: '',
                  recordIdEnd: 5,
                  recordIdStart: 0,
                  recordType: '',
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        // setFilterCode("");
                        // setFilterCodeName("");
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: true,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            localization={{
              body: {editRow: {deleteText: 'Are you sure you want to delete this filter?'}},
            }}
            // actions={[
            //   {
            //     icon: () => (
            //       <>
            //         <FileCopyIcon />
            //       </>
            //     ),
            //     tooltip: "copy",
            //     onClick: (event, rowData) => {
            //       setFilterCode(rowData?.id);
            //       setFilterCodeName(rowData?.name);
            //       setIsCopyRowData(true);
            //       setValueCode(1);
            //     },
            //   },
            //   {
            //     icon: "visibility",
            //     tooltip: "Usage",
            //     onClick: (event, rowData) => {
            //       setDeleteUsage(false);
            //       dispatch(fetchFilterUsage(rowData.name));
            //     },
            //   },
            //   {
            //     icon: "delete",
            //     tooltip: "Delete",
            //     onClick: (event, rowData) => {
            //       // handleDelete(rowData);
            //       // dispatch(fetchFilterUsage(rowData.name));
            //     },
            //   },
            //   //commented for future use
            //   // {
            //   //   icon: () => (
            //   //     <>
            //   //       <Button
            //   //         type="button"
            //   //         variant="contained"
            //   //         className={`themeing-buttons ${classes.buttonRoot}`}
            //   //         color="primary"
            //   //       >
            //   //         Print Usage
            //   //       </Button>
            //   //     </>
            //   //   ),
            //   //   tooltip: "Print Usage",
            //   //   isFreeAction: true,
            //   //   onClick: (event) => {},
            //   // },
            //   // {
            //   //   icon: () => (
            //   //     <>
            //   //       <Button
            //   //         variant="contained"
            //   //         className={`themeing-buttons ${classes.buttonRoot}`}
            //   //         onClick={() => {
            //   //           dispatch(
            //   //             printFilter({
            //   //               description: searchData?.description ? searchData?.description : "",
            //   //               name: searchData?.name ? searchData.name : "",
            //   //             })
            //   //           );
            //   //         }}
            //   //       >
            //   //         Print
            //   //       </Button>
            //   //     </>
            //   //   ),
            //   //   tooltip: "Print",
            //   //   isFreeAction: true,
            //   // },
            // ]}
            actions={[
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn`}
                      // disabled={dataCount === 0}
                    >
                      Add Record Group
                    </Button>
                  </>
                ),
                isFreeAction: true,
                onClick: (event) => {
                  setValue(1);
                },
              },
            ]}
            onRowClick={(event, rowData) => {
              setFilterCode(rowData?.recordGroupCode);
              // setFilterCodeName(rowData?.name);
              setValue(1);
              // dispatch(rowData.)
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}

                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}

                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
          {message && <SuccessSnackbar successMsg={message} />}
        </div>
      </Grid>
    </>
  );
}
